import { SvgIcon, type SvgIconProps } from './svgIcon'

export function GradeIcon({ width = 26, height = 22, ...props }: SvgIconProps) {
  return (
    <SvgIcon
      width={width}
      height={height}
      // viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <path
        d="M5.84994 13.825L8.99994 11.925L12.1499 13.85L11.3249 10.25L14.0999 7.84998L10.4499 7.52498L8.99994 4.12498L7.54994 7.49998L3.89994 7.82498L6.67494 10.25L5.84994 13.825ZM3.57499 16.9614L5.00767 10.7923L0.221191 6.64423L6.53652 6.09618L8.99994 0.278931L11.4634 6.09618L17.7787 6.64423L12.9922 10.7923L14.4249 16.9614L8.99994 13.6884L3.57499 16.9614Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
